var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center p-3"
  }, [_c('select', {
    staticClass: "form-control select-category mr-2"
  }, _vm._l(_vm.categories, function (i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))]);
  }), 0), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-category",
      modifiers: {
        "modal-category": true
      }
    }],
    staticClass: "p-2 btn"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-filter.svg")
    }
  })]), _c('b-modal', {
    attrs: {
      "id": "modal-category",
      "title-class": "modal-category-title",
      "title": "商品分類",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', {
          staticClass: "mb-0 w-100 text-center"
        }, [_vm._v("商品分類")]), _c('b-button', {
          staticClass: "close",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("./images/icon-close.svg")
          }
        })])];
      }
    }, {
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', {
          staticClass: "row w-100",
          style: _vm.colorObject
        }, [_c('div', {
          staticClass: "col"
        }, [_c('b-button', {
          staticClass: "w-100",
          attrs: {
            "size": "lg",
            "variant": "outline-dark"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")])], 1), _c('div', {
          staticClass: "col"
        }, [_c('b-button', {
          staticClass: "w-100",
          attrs: {
            "size": "lg",
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認 ")])], 1)])];
      }
    }])
  }, [_c('div', {
    staticClass: "row filters"
  }, _vm._l(_vm.categories, function (i) {
    return _c('div', {
      key: i,
      staticClass: "col-6 mb-2",
      style: _vm.colorObject
    }, [_c('button', {
      staticClass: "btn btn-light rounded-pill w-100 p-2 filter"
    }, [_vm._v(" " + _vm._s(i) + " ")])]);
  }), 0)]), _c('button', {
    staticClass: "p-2 btn",
    on: {
      "click": function click($event) {
        _vm.currentView = _vm.gridViews[(_vm.gridViews.indexOf(_vm.currentView) + 1) % _vm.gridViews.length];
      }
    }
  }, [_vm.currentView == _vm.gridViews[0] ? _c('img', {
    attrs: {
      "src": require("./images/icon-grid-2.svg")
    }
  }) : _vm._e(), _vm.currentView == _vm.gridViews[1] ? _c('img', {
    attrs: {
      "src": require("./images/icon-grid-1.svg")
    }
  }) : _vm._e(), _vm.currentView == _vm.gridViews[2] ? _c('img', {
    attrs: {
      "src": require("./images/icon-grid-list.svg")
    }
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "products",
    class: _vm.currentView
  }, _vm._l(_vm.products, function (p) {
    return _c('div', {
      key: p.id
    }, [_c('router-link', {
      staticClass: "products__item",
      attrs: {
        "role": "button",
        "to": {
          name: 'LiffShopProduct',
          params: {
            id: p.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "products__item__photo product__photo"
    }, [_vm.getImage(p) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": _vm.getImage(p)
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "products__item__title product__title"
    }, [_vm._v(_vm._s(p.title))]), _c('div', {
      staticClass: "products__item__brand"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(p.description)
      }
    })]), _c('div', {
      staticClass: "products__item__price"
    }, [_c('div', [_c('div', {
      staticClass: "oprice"
    }, [_vm._v(_vm._s(p.original_price))]), _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(p.price))])]), _c('button', {
      staticClass: "btn bag"
    }, [_c('img', {
      attrs: {
        "src": require("./images/icon-shopping-bag.svg")
      }
    })])])])], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }